import { gql } from "@apollo/client"
import { PLAN_CONTRIBUTION_SETTINGS_FRAGMENT } from "~/shared/fragments/PlanContributionSettingFragment"

export const PLANS_QUERY = gql`
  ${PLAN_CONTRIBUTION_SETTINGS_FRAGMENT}
  query AdminBenefitsPlans($query: String, $providerId: ID) {
    benefitPlans(query: $query, providerId: $providerId) {
      collection {
        id
        name
        category
        provider {
          id
          name
        }
        ...PlanContributionSettingFragment
        priceEstimate {
          currencies {
            currencyCode
            subunit
            subunitToUnit
          }
        }
      }
    }
  }
`
